var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedLockSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.66667H14.625V5.47619C14.625 2.45333 12.105 0 9 0C5.895 0 3.375 2.45333 3.375 5.47619V7.66667H2.25C1.0125 7.66667 0 8.65238 0 9.85714V20.8095C0 22.0143 1.0125 23 2.25 23H15.75C16.9875 23 18 22.0143 18 20.8095V9.85714C18 8.65238 16.9875 7.66667 15.75 7.66667ZM5.625 5.47619C5.625 3.6581 7.1325 2.19048 9 2.19048C10.8675 2.19048 12.375 3.6581 12.375 5.47619V7.66667H5.625V5.47619ZM15.75 20.8095H2.25V9.85714H15.75V20.8095ZM9 17.5238C10.2375 17.5238 11.25 16.5381 11.25 15.3333C11.25 14.1286 10.2375 13.1429 9 13.1429C7.7625 13.1429 6.75 14.1286 6.75 15.3333C6.75 16.5381 7.7625 17.5238 9 17.5238Z",
    fill: "#00479B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedLockSvg);
export default __webpack_public_path__ + "static/media/ClosedLockSVG.37e98431952a7a92ff012df000d3b8d7.svg";
export { ForwardRef as ReactComponent };